import styled from 'styled-components';

const ListSubheader = styled.h3`
  padding: 6px 0;
  margin: 0;
  margin-bottom: 5px;
  font-family: inherit;
  font-size: ${props => props.textFontSize || 14}px !important;
  font-weight: 400 !important;
  line-height: 18px;
  color: ${props => props.color} !important;
  border-bottom: 1px solid #c4d1d8 !important;
`;

export default ListSubheader;
